export default __webpack_public_path__ + "static/media/hostfully_step8.f515eebf.png";